import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Router } from '@angular/router';
import {environment} from '../../environments/environment'
import { TranslateService } from '@ngx-translate/core'

//let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

@Injectable({
  providedIn: "root"
})
export class InstalacionesService {

  public activeLang;

  constructor(private http: HttpClient, private router: Router, private translate: TranslateService) {

    this.translate.setDefaultLang(this.activeLang);
  }

  mostrar_instalaciones(id_user:any):Observable<any>{

   // return this.http.get(`${environment.servidor}/instalaciones/${id_user}`);
    return this.http.post<any>(environment.servidor+"/instalaciones", {id_user})

   //return this.http.get(environment.servidor + "/instalaciones/" + id_user, { headers });
   //return this.http.get(environment.servidor+"/instalaciones/"+id_user)
    //return this.http.get("/instalaciones/"+id_user)
  }

  mostrar_usuarios_para_admin():Observable<any>{
    return this.http.get(environment.servidor+"/todosUsuarios")
    //return this.http.post<any>(environment.servidor+"/todosUsuarios", {usuario})
    //return this.http.get("/instalaciones/"+id_user)
  }

  mostrar_usuarios_inst_admin():Observable<any>{
    return this.http.get(environment.servidor+"/mostrar_user_inst")
    //return this.http.post<any>(environment.servidor+"/mostrar_user_inst", {usuario})
    //return this.http.get("/instalaciones/"+id_user)
  }

  mostrar_nom_instalaciones():Observable<any>{
    return this.http.get(environment.servidor+"/mostrar_nom_inst")
    //return this.http.post<any>(environment.servidor+"/mostrar_nom_inst", {usuario})
    //return this.http.get("/instalaciones/"+id_user)
  }

  mostrar_nombrespaisesinstalaciones(id_user:any, usuario:any):Observable<any>{

    //return this.http.get(`${environment.servidor}/nombrespaisesinstalaciones/${id_user}`, { headers });
    //return this.http.get(environment.servidor+"/nompaisesinstalaciones/"+id_user
    return this.http.post<any>(environment.servidor+"/nompaisesinstalaciones", {id_user, usuario})

    }

  mostrar_alertas(id_inst:any, usuario:any):Observable<any>{
    //return this.http.get(environment.servidor+"/todasAlertas/"+id_inst)
    return this.http.post<any>(environment.servidor+"/todasAlertas", {id_inst, usuario})
    //return this.http.get("/instalaciones/"+id_user)
  }

  mostrar_alerta_en_cuestion(id_alerta:any, usuario:any):Observable<any>{
   // return this.http.get(environment.servidor+"/getAlertaEnCuestion/"+id_alerta)
    return this.http.post<any>(environment.servidor+"/getAlertaEnCuestion", {id_alerta, usuario})
    //return this.http.get("/instalaciones/"+id_user)
  }

  modificar_dh_alerta_count(id_nodo:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/dh_count_nodo", {id_nodo})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }

  modificar_dv_alerta_count(id_nodo:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/dv_count_nodo", {id_nodo})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }

  modificar_incl_l_alerta_count(id_nodo:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/incl_l_count_nodo", {id_nodo})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }

  modificar_incl_t_alerta_count(id_nodo:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/incl_t_count_nodo", {id_nodo})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }

  modificar_acel_l_alerta_count(id_nodo:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/acel_l_count_nodo", {id_nodo})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }

  modificar_acel_t_alerta_count(id_nodo:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/acel_t_count_nodo", {id_nodo})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }

  modificar_acel_v_alerta_count(id_nodo:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/acel_v_count_nodo", {id_nodo})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }

  modificar_temp_alerta_count(id_nodo:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/temp_count_nodo", {id_nodo})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }

  
  modificar_hum_alerta_count(id_nodo:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/hum_count_nodo", {id_nodo})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }

  modificar_no_data_alerta_count(id_nodo:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/no_data_alert_nodo", {id_nodo})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }

  modificar_alertas(id:any, revisada:any, observaciones:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/modificarAlertas", {id, revisada, observaciones})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }

  modificar_token_user(token:any, id:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/modificarTokenUser", {token, id})
  }

  mostrar_instalaciones_filtro_por_nombre(pais:any, id_user:any):Observable<any>{
    return this.http.get(environment.servidor+"/instalaciones/"+pais+"/"+id_user)
    //return this.http.get("/instalaciones/"+id+"/"+id_user)
  }

  mostrar_nodos_select(id:any, usuario:any):Observable<any>{
    //return this.http.get(environment.servidor+"/nodos/"+id)
    return this.http.post<any>(environment.servidor+"/nodos", {id, usuario})
    //return this.http.get("/nodos/"+id)
  }

  mostrar_modelo_3d(id:any, usuario:any):Observable<any>{
    //return this.http.get(environment.servidor+"/modelo/"+id)
    return this.http.post<any>(environment.servidor+"/modelo", {id, usuario})
    //return this.http.get("/modelo/"+id)
  }

  mostrar_nodos_data(id:any, usuario:any):Observable<any>{
   // return this.http.get(environment.servidor+"/nodosdata/"+id)
    return this.http.post<any>(environment.servidor+"/nodosdata", {id, usuario})
    //return this.http.get("/nodosdata/"+id)
  }

  mostrar_info_junta_nodo(id:any, usuario:any):Observable<any>{
    //return this.http.get(environment.servidor+"/nodoinfojunta/"+id)
    return this.http.post<any>(environment.servidor+"/nodoinfojunta", {id, usuario})
    //return this.http.get("/nodosdata/"+id)
  }

  mostrar_nodos_data_general(id:any, usuario:any):Observable<any>{
    //return this.http.get(environment.servidor+"/nodosdatageneral/"+id)
    return this.http.post<any>(environment.servidor+"/nodosdatageneral", {id, usuario})
    //return this.http.get("/nodosdatageneral/"+id)
  }

  mostrar_nodos_data_last_day(id:any):Observable<any>{
    return this.http.get(environment.servidor+"/nodosdataUltDia/"+id)
    //return this.http.get("/nodosdatageneral/"+id)
  }


  mostrar_nodos_data_last_week(id:any, usuario:any):Observable<any>{
    //return this.http.get(environment.servidor+"/nodosdatalastweek/"+id)
    return this.http.post<any>(environment.servidor+"/nodosdatalastweek", {id, usuario})
    //return this.http.get("/nodosdatageneral/"+id)
  }

  mostrar_nodos_data_last_year(id:any, usuario:any):Observable<any>{
    //return this.http.get(environment.servidor+"/nodosdatalastyear/"+id)
    return this.http.post<any>(environment.servidor+"/nodosdatalastyear", {id, usuario})
    //return this.http.get("/nodosdatageneral/"+id)
  }

  mostrar_nodos_data_desde_inicio(id:any, usuario:any):Observable<any>{
    //return this.http.get(environment.servidor+"/nodosdatadesdeinicio/"+id)
    return this.http.post<any>(environment.servidor+"/nodosdatadesdeinicio", {id, usuario})
    //return this.http.get("/nodosdatageneral/"+id)
  }

  insertar_config(nombre_nodo:any, incl_ini_l:any, incl_ini_t:any, ln_junta:any, modelo_junta:any, l_inst:any, dh_ini:any, dv_ini:any, dir_v:any, dir_l:any, dir_t:any, dh_alerta:any, dh_alerta_check:any, dv_alerta:any, dv_alerta_check:any, incl_l_alerta:any, incl_l_alerta_check:any, incl_t_alerta:any, incl_t_alerta_check:any, acel_l_alerta:any, acel_t_alerta:any, acel_v_alerta:any, acel_alerta_check:any, temp_alerta:any, temp_alerta_check:any, hum_alerta:any, hum_alerta_check:any, status:any, id:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/config", {nombre_nodo, incl_ini_l, incl_ini_t, ln_junta, modelo_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, dh_alerta, dh_alerta_check, dv_alerta, dv_alerta_check, incl_l_alerta, incl_l_alerta_check, incl_t_alerta, incl_t_alerta_check, acel_l_alerta, acel_t_alerta, acel_v_alerta, acel_alerta_check, temp_alerta, temp_alerta_check, hum_alerta, hum_alerta_check, status, id})
    //return this.http.post<any>("/config", {incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, id})
  }


  insertar_frec(frec:any, alertas:any, id:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/configFrec", {frec, alertas, id})
    //return this.http.post<any>("/configFrec", {frec, id})
  }

  obtener_mac_nodo_central(id:any):Observable<any>{
    return this.http.get(environment.servidor+"/obtenermacnodocentral/"+id)
    //return this.http.get("/obtenerconfig/"+id)
  }

  modificar_user(id:any, nombre:any, empresa:any, tlf:any, usuario_bd:any, rol:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/modificarUser", {id, nombre, empresa, tlf, usuario_bd, rol})
    //return this.http.post<any>("/configFrec", {frec, id})
  }

  modificar_user_pass(id:any, nombre:any, empresa:any, tlf:any, usuario_bd:any, pass:any, rol:any, token:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/modificarUserPass", {id, nombre, empresa, tlf, usuario_bd, pass, rol, token})
    //return this.http.post<any>("/configFrec", {frec, id})
  }

  modificar_user_inst(id:any, id_inst:any, id_usuario:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/modificarUserInst", {id, id_inst, id_usuario})
    //return this.http.post<any>("/configFrec", {frec, id})
  }

  modificar_status_nodo(id_nodo:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/updateStatusNodo", {id_nodo})
    //return this.http.post<any>("/configFrec", {frec, id})
  }

  modificar_status_inst(id_inst:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/updateStatusInst", {id_inst})
    //return this.http.post<any>("/configFrec", {frec, id})
  }

  obtener_id_usuario(nombre:any):Observable<any>{
    return this.http.get(environment.servidor+"/getIdUser/"+nombre)
    //return this.http.get("/obtenerconfig/"+id)
  }

  mostrar_data_config(id:any, usuario:any):Observable<any>{
    //return this.http.get(environment.servidor+"/obtenerconfig/"+id)
    return this.http.post<any>(environment.servidor+"/obtenerconfig", {id, usuario})
    //return this.http.get("/obtenerconfig/"+id)
  }

  mostrar_frec_inst(id:any, usuario:any):Observable<any>{
   // return this.http.get(environment.servidor+"/frecInst/"+id)
    return this.http.post<any>(environment.servidor+"/frecInst", {id, usuario})
    //return this.http.get("/frecInst/"+id)
  }

  insertar_edificio_nuevo(nombre:any, ciudad:any, pais:any, coord_x:any, coord_y:any, img:any, urlModelo3d:any, frec:any, status:any, alertas:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/edificioNuevo", {nombre, ciudad, pais, coord_x, coord_y, img, urlModelo3d, frec, status, alertas})
    //return this.http.post<any>("/edificioNuevo", {nombre, mac, ciudad, pais, coord_x, coord_y, img, urlModelo3d, frec, id_usuario})
  }

  anadir_registro_inst_user(id_inst:any, id_usuario:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/InstUserNuevo", {id_inst, id_usuario})
    //return this.http.post<any>("/edificioNuevo", {nombre, mac, ciudad, pais, coord_x, coord_y, img, urlModelo3d, frec, id_usuario})
  }

  insertar_inst_user(id_inst:any, id_usuario:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/InstUser", {id_inst, id_usuario})
    //return this.http.post<any>("/edificioNuevo", {nombre, mac, ciudad, pais, coord_x, coord_y, img, urlModelo3d, frec, id_usuario})
  }

  insertar_nodo_nuevo(nom_nodo:any, id_nodo_central:any, mac:any, incl_ini_l:any, incl_ini_t:any, ln_junta:any, modelo_junta:any, l_inst:any, dh_ini:any, dv_ini:any, dir_v:any, dir_l:any, dir_t:any, dh_alerta:any, dh_alerta_check:any, dh_alerta_count:any, dv_alerta:any, dv_alerta_check:any, dv_alerta_count:any, incl_l_alerta:any, incl_l_alerta_check:any, incl_l_alerta_count:any, incl_t_alerta:any, incl_t_alerta_check:any, incl_t_alerta_count:any, acel_l_alerta:any, acel_t_alerta:any, acel_v_alerta:any, acel_alerta_check:any, acel_alert_count_l:any, acel_alert_count_t:any, acel_alert_count_v:any, temp_alerta:any, temp_alerta_check:any, temp_alerta_count:any, hum_alerta:any, hum_alerta_check:any, hum_alerta_count:any, no_data_alert:any, status:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/nodoNuevo", {nom_nodo, id_nodo_central, mac, incl_ini_l, incl_ini_t, ln_junta, modelo_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t, dh_alerta, dh_alerta_check, dh_alerta_count, dv_alerta, dv_alerta_check, dv_alerta_count, incl_l_alerta, incl_l_alerta_check, incl_l_alerta_count, incl_t_alerta, incl_t_alerta_check, incl_t_alerta_count, acel_l_alerta, acel_t_alerta, acel_v_alerta, acel_alerta_check, acel_alert_count_l, acel_alert_count_t, acel_alert_count_v, temp_alerta, temp_alerta_check, temp_alerta_count, hum_alerta, hum_alerta_check, hum_alerta_count, no_data_alert, status})
    //return this.http.post<any>("/nodoNuevo", {nom_nodo, id_instalacion, mac, incl_ini_l, incl_ini_t, ln_junta, l_inst, dh_ini, dv_ini, dir_v, dir_l, dir_t})
  }

  insertar_nodo_central_nuevo(mac:any, id_instalacion:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/nodoCentralNuevo", {mac, id_instalacion})
  }

  ultimo_id_edificio():Observable<any>{
    return this.http.get(environment.servidor+"/ultimoId")
    //return this.http.get("/ultimoId")
  }

  insertar_img_edificio(image: File):Observable<any>{
    const formData = new FormData();

    formData.append('image', image);

    return this.http.post<any>(environment.servidor+"/uploadImg", formData)
    //return this.http.post<any>("/uploadImg", formData)
  }

  guardar_listado_contactos(id_inst:any, texto:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/listadoContactos", {id_inst, texto})
    //return this.http.post<any>("/edificioNuevo", {nombre, mac, ciudad, pais, coord_x, coord_y, img, urlModelo3d, frec, id_usuario})
  }

  leer_listado_contactos(id_inst:any):Observable<any>{
    return this.http.post(environment.servidor+"/leerListadoContactos", {id_inst})
  }

  guardar_frec_archivo_txt(id_nodo_central:any, frec:any):Observable<any>{
    let frecuenciaString = frec.toString();
    return this.http.post<any>(environment.servidor+"/guardarfrecarchivotxt", {id_nodo_central, frecuenciaString})
    //return this.http.post<any>("/edificioNuevo", {nombre, mac, ciudad, pais, coord_x, coord_y, img, urlModelo3d, frec, id_usuario})
  }

  login1(usuario:any):Observable<any>{
    return this.http.get(environment.servidor+"/login1/"+usuario)
    //return this.http.get("/login/"+usuario)
  }

  login(usuario: any, password: any): Observable<any> {

      const datos = { usuario, password }; // Crear el objeto con los datos
      return this.http.post(environment.servidor + "/login", datos);
      
  }
  

  seleccionar_ids_nodos_centrales(mac:any):Observable<any>{
    return this.http.get(environment.servidor+"/obtenerIdsNodoCentral/"+mac)
    //return this.http.get("/login/"+usuario)
  }

  insertar_usuario_nuevo(nombre:any, empresa:any, tlf:any, usuario:any, contr:any, rol:any, token:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/usuarioNuevo", {nombre, empresa, tlf, usuario, contr, rol, token})
    //return this.http.post<any>("/usuarioNuevo", {nombre, empresa, tlf, usuario, contr, token})
  }

  insertar_usuario_nuevo_desde_admin(nombre:any, empresa:any, tlf:any, usuario:any, contr:any, rol:any, token:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/usuarioNuevoDesdeAdmin", {nombre, empresa, tlf, usuario, contr, rol, token})
    //return this.http.post<any>("/usuarioNuevo", {nombre, empresa, tlf, usuario, contr, token})
  }

  generarToken(usuario:any, pass:any):Observable<any>{
    //user:any
    return this.http.post<any>(environment.servidor+"/generateToken", {usuario, pass})
    //return this.http.post<any>("/generateToken", {user})
  }

  verificarToken(token:any, user:any, pass:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/verifyToken", {token, user, pass})
    //return this.http.post<any>("/verifyToken", {token})
  }

  verificarTokenUser(token:any, user:any):Observable<any>{
    return this.http.post<any>(environment.servidor+"/verifyTokenUser", {token, user})
    //return this.http.post<any>("/verifyToken", {token})
  }

  enviar_correo(body):Observable<any>{
    return this.http.post(environment.servidor+"/formulario", body)
  }

  enviar_correo_alta_user(body):Observable<any>{
    return this.http.post(environment.servidor+"/formularioAltaUser", body)
  }
  

  public cambiarLenguaje(evento) {
    //console.log(evento)
    this.activeLang = evento;
    this.translate.use(evento);
    localStorage.setItem('idioma', evento)

    console.log(this.activeLang)

    this.router.navigate(['/pages/login']).then(() => {
      window.location.reload();
    });
    
  }

  borrar_alerta(id:any):Observable<any>{
    return this.http.delete(environment.servidor+"/borrarAlerta/"+id)
    //return this.http.get("/login/"+usuario)
  }

  borrar_usuario(id:any):Observable<any>{
    return this.http.delete(environment.servidor+"/borrarUser/"+id)
    //return this.http.get("/login/"+usuario)
  }

  borrar_usuario_previo(id:any):Observable<any>{
    return this.http.delete(environment.servidor+"/borrarUserPrevio/"+id)
    //return this.http.get("/login/"+usuario)
  }

  borrar_usuario_inst(id:any):Observable<any>{
    return this.http.delete(environment.servidor+"/borrarUserInst/"+id)
    //return this.http.get("/login/"+usuario)
  }

}